























import {Component, Vue} from 'vue-property-decorator';
import SuppliersTable from '@/screens/dashboard/supplier/SuppliersTable.vue';
import {Location} from 'vue-router';

@Component({
  components: {
    SuppliersTable
  }
})
export default class SupplierScreen extends Vue {
  get newSupplierRoute(): Location {
    return { name: 'dashboard.suppliers.new' };
  }
}
